<template>
  <span class="volume-wrapper" :id="`volume-level-${callId}`">
    <img src="../assets/volume-icon.jpg" width="17" height="17"/>
  </span>
</template>

<script>
export default {
  name: "VolumeLevelIndicator",
  props: {
    stream: {
      type: MediaStream,
      required: true
    },
    callId: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 20
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    barColor: {
      type: String,
      default: "black"
    }
  },
  methods: {
    getMaxSmallIndicatorHeight(value) {
      const halfLineHeight = this.height / 4
      return value < halfLineHeight ? value : halfLineHeight
    },
    getVolumeLevelBar(stream, callId) {
      let audioContext = new AudioContext();
      let analyser = audioContext.createAnalyser();
      let microphone = audioContext.createMediaStreamSource(stream);
      let javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 1024;

      microphone.connect(analyser);
      analyser.connect(javascriptNode);
      javascriptNode.connect(audioContext.destination);

      const canvas = document.createElement("canvas");
      canvas.setAttribute("id", "canvas");

      const indicatorWidth = this.lineWidth * 5
      const halfLineHeight = this.height / 2

      canvas.setAttribute("width", `${indicatorWidth}`);
      canvas.setAttribute("height", `${this.height}`);

      document.getElementById(`volume-level-${callId}`).appendChild(canvas);
      let canvasContext = canvas.getContext("2d");

      javascriptNode.onaudioprocess = () => {
        let array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        let values = 0;

        let length = array.length;
        for (let i = 0; i < length; i++) {
          values += (array[i]);
        }

        let average = values / length;

        canvasContext.fillStyle = this.barColor;
        const halfValue = average / 2
        canvasContext.clearRect(0, halfLineHeight, this.lineWidth, halfLineHeight);
        canvasContext.fillRect(0, halfLineHeight, this.lineWidth, this.getMaxSmallIndicatorHeight(halfValue));
        canvasContext.clearRect(0, halfLineHeight, this.lineWidth, -halfLineHeight);
        canvasContext.fillRect(0, halfLineHeight, this.lineWidth, 0 - this.getMaxSmallIndicatorHeight(halfValue));

        canvasContext.clearRect(this.lineWidth * 2, halfLineHeight, this.lineWidth, halfLineHeight);
        canvasContext.fillRect(this.lineWidth * 2, halfLineHeight, this.lineWidth, average);
        canvasContext.clearRect(this.lineWidth * 2, halfLineHeight, this.lineWidth, -halfLineHeight);
        canvasContext.fillRect(this.lineWidth * 2, halfLineHeight, this.lineWidth, 0 - average);

        canvasContext.clearRect(this.lineWidth * 4, halfLineHeight, this.lineWidth, halfLineHeight);
        canvasContext.fillRect(this.lineWidth * 4, halfLineHeight, this.lineWidth, this.getMaxSmallIndicatorHeight(halfValue));
        canvasContext.clearRect(this.lineWidth * 4, halfLineHeight, this.lineWidth, -halfLineHeight);
        canvasContext.fillRect(this.lineWidth * 4, halfLineHeight, this.lineWidth, 0 - this.getMaxSmallIndicatorHeight(halfValue));
      }
    }
  },
  mounted() {
    this.getVolumeLevelBar(this.stream, this.callId)
  }
}
</script>

<style scoped>
.volume-wrapper {
  margin: 0 10px;
}
</style>